import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IApisLoginResponse } from '../../../entity/interface/iAuthApis';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IUserDetailsEntity } from '../../../entity';

export interface ILoginWithOTPUseCase {
    execute(
        username: string,
        otp: string,
        lang: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IUserDetailsEntity>;
}

export class LoginWithOTPUseCase implements ILoginWithOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        otp: string,
        lang: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string
    ): Promise<IUserDetailsEntity> {
        const response = await this.authRepo.loginWithOTP(username, otp, lang, apiToken, recaptchaToken);
        return response.data as IUserDetailsEntity;
    }
}
